import React, { Component } from 'react';

import PropTypes from 'prop-types';
import Select from 'react-select'

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ClearIcon from '@material-ui/icons/Clear'

const _ = require('lodash');

const ITEM_HEIGHT = 48;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    // We had to use a lot of global selectors in order to style react-select.
    // We are waiting on https://github.com/JedWatson/react-select/issues/1679
    // to provide a much better implementation.
    // Also, we had to reset the default style injected by the library.
    '@global': {
        '.Select-control': {
            display: 'flex',
            alignItems: 'center',
            border: 0,
            height: 'auto',
            background: 'transparent',
            '&:hover': {
                boxShadow: 'none'
            }
        },
        '.Select-multi-value-wrapper': {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap'
        },
        '.Select--multi .Select-input': {
            margin: 0
        },
        '.Select.has-value.is-clearable.Select--single > .Select-control .Select-value': {
            padding: 0
        },
        '.Select-noresults': {
            padding: theme.spacing.unit * 2
        },
        '.Select-input': {
            display: 'inline-flex !important',
            padding: 0,
            height: 'auto'
        },
        '.Select-input input': {
            background: 'transparent',
            border: 0,
            padding: 0,
            cursor: 'default',
            display: 'inline-block',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            margin: 0,
            outline: 0
        },
        '.Select-placeholder, .Select--single .Select-value': {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(16),
            padding: 0
        },
        '.Select-placeholder': {
            opacity: 0.42,
            color: theme.palette.common.black
        },
        '.Select-menu-outer': {
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[2],
            position: 'absolute',
            zIndex: 999,
            left: 0,
            top: `calc(100% + ${theme.spacing.unit}px)`,
            width: '100%',
            maxHeight: ITEM_HEIGHT * 4.5
        },
        '.Select.is-focused:not(.is-open) > .Select-control': {
            boxShadow: 'none'
        },
        '.Select-menu': {
            maxHeight: ITEM_HEIGHT * 4.5,
            overflowY: 'auto'
        },
        '.Select-menu div': {
            boxSizing: 'content-box',
        },
        '.Select-value': {
            marginRight: 5
        },
        '.Select-arrow-zone, .Select-clear-zone': {
            color: theme.palette.action.active,
            cursor: 'pointer',
            height: 21,
            width: 21,
            zIndex: 1
        },
        // Only for screen readers. We can't use display none.
        '.Select-aria-only': {
            position: 'absolute',
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
            height: 1,
            width: 1,
            margin: -1
        },
    }
});


class SearchableDropdown extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            open: false
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { value } = this.props;
        if (!_.isEqual(prevState.value, value)) {
            this.setState({ value });
        }
    }

    handleChange = value => {
        const { onChange } = this.props;
        onChange(value);
        this.setState({ value });
    };

    render() {
        const { classes, options, placeholder, name, label, multiple, autoClose, disabled, margin } = this.props;
        const { value } = this.state;
        return (
            <TextField className={classes.root} name={name} fullWidth margin={margin}
                value={value} onChange={this.handleChange}
                placeholder={placeholder} label={label} disabled={disabled}
                InputLabelProps={{ shrink: true, }}
                InputProps={{
                    inputComponent: WrappedSelect,
                    inputProps: {
                        classes,
                        multi: multiple,
                        simpleValue: true,
                        options: options,
                        closeOnSelect: !multiple && autoClose,
                        removeSelected: false
                    },
                }}
            />
        );
    }
}

function WrappedSelect(props) {
    const { classes, ...other } = props;
    return (
        <Select optionComponent={Option} noResultsText={<Typography>{'No results found'}</Typography>}
            arrowRenderer={arrowProps => arrowProps.isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            clearRenderer={() => <ClearIcon />} valueComponent={valueProps =>
                <div className="Select-value">{valueProps.children}{props.multi && " ,"}</div>
            } {...other} />
    );
}

class Option extends Component {

    handleClick = event => {
        this.props.onSelect(this.props.option, event);
    };

    render() {
        const { children, isFocused, isSelected, onFocus } = this.props;
        return (
            <MenuItem onFocus={onFocus} selected={isFocused}
                onClick={this.handleClick} component="div"
                style={{ fontWeight: isSelected ? 500 : 400 }} >
                <Checkbox checked={isSelected} />
                {children}
            </MenuItem>
        );
    }
}

SearchableDropdown.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SearchableDropdown);



// WEBPACK FOOTER //
// ./src/Components/Presentation/_Shared/SearchableDropdown.js